export const ACTION_CARD_COUNTS = {
    BANZAI: 2,
    CANARDAGE: 1,
    DISPERSION: 2,
    DOUBLE_VISEUR: 1,
    EN_AVANT_MARCHE: 6,
    EN_JOUE: 11,
    PALME_ARRIERE: 3,
    PALME_AVANT: 3,
    PAN: 13,
    RECTIFIER_TIR_DROITE: 2,
    RECTIFIER_TIR_GAUCHE: 2,
    TIREUR_DELITE: 1,
    TU_LOUCHES: 2,
    PLANQUE: 2,
};
